var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"introduction"},[_c('div',{staticClass:"main"},[_c('div',{staticClass:"banner"},[_c('img',{attrs:{"src":_vm.pagePicture}})]),_c('div',{staticClass:"list",domProps:{"innerHTML":_vm._s(_vm.pageContent)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }